import Api from "../helpers/api";

export const vratGeojsonData = async (typ, id) => {
  if (!typ || !id) {
    return false;
  }
  try {
    const response = await Api.get(`/api/v1/smartmap/geojson/${typ}/${id}`);
    if (response.data.features.length === 0) {
      response.data.features.push({
        type: "Feature",
        properties: {
          id: "0",
          gistyp: "adresy",
          nazov: "Bez adresy",
        },
        geometry: {
          type: "Point",
          coordinates: [18.145458, 48.971705],
        },
      });
    }
    return response.data || false;
  } catch (error) {
    console.error(error);
  }
};
